"use strict"

import React, {useEffect} from "react"
import {observer} from "mobx-react"

import {injectIntl} from "react-intl"
import {Container, Typography, Grid, Box} from "@material-ui/core"
import XsButton from "../../global/ui/xsButton/xsButton"
import RouterStore from "../../global/store/RouterStore"
import GlobalStore from "../../global/store/GlobalStore"
import api from "../../global/actions/api"

function MaintenanceContainer() {
	useEffect(() => {
		api.appInfo().call()

		return () => {
			GlobalStore.maintenanceDesc = null
		}
	}, [])

	return (
		<Container maxWidth="md">
			<Grid container direction="column" spacing={8} style={{textAlign: "center"}}>
				<Grid item>
					<Box pt={8}>
						<Typography variant="h3">Žiadosti o vydanie poukážky</Typography>
					</Box>
				</Grid>
				<Grid item container direction="column" spacing={4}>
					<Grid item>
						{/* <Typography variant="h6" style={{fontWeight: "normal"}}>
							Na prostredí prebieha plánovaná údržba od 
						</Typography> */}
						{isNotEmpty(GlobalStore.maintenanceDesc) && (
							<Typography variant="h6" style={{fontWeight: "normal"}}>
								{GlobalStore.maintenanceDesc}
							</Typography>
						)}
					</Grid>
					<Grid item className="mt-8">
						<XsButton
							fullWidth={false}
							text="OBNOVIŤ STRÁNKU"
							icon={<i className="fas fa-sync"></i>}
							onClick={() => RouterStore.push("/")}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	)
}

export default injectIntl(observer(MaintenanceContainer))

